// src/Contexts/AuthContext.js

import React, { createContext, useContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuth, setIsAuth] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        try {
          const token = await firebaseUser.getIdToken(true); // トークンを強制的にリフレッシュ
          // console.log("Token refreshed:", token);
          setIsAuth(true);
          setUser(firebaseUser);
        } catch (error) {
          console.error("Token refresh failed", error);
          await auth.signOut();
          setIsAuth(false);
          setUser(null);
        }
      } else {
        setIsAuth(false);
        setUser(null);
      }
    });

    return () => unsubscribe(); // クリーンアップ
  }, []);

  return (
    <AuthContext.Provider value={{ isAuth, setIsAuth, user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
